import { render, staticRenderFns } from "./upload-material-dialog.vue?vue&type=template&id=2931dfa8&scoped=true&"
import script from "./upload-material-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-material-dialog.vue?vue&type=script&lang=js&"
import style0 from "./upload-material-dialog.vue?vue&type=style&index=0&id=2931dfa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931dfa8",
  null
  
)

export default component.exports